import { getTokenData } from '../../helpers/decodeToken';
import { LocalStorageService } from '../../services/localStorageService';
import {
  AuthActionTypes,
  AuthState,
  LOGGED_IN,
  LOGGED_OUT,
  SET_REFRESH_IN_PROGRESS,
} from './types';

function parseToken(
  token?: string | null,
  refreshToken?: string | null,
): AuthState {
  if (!token) {
    return {};
  }
  const { username, exp } = getTokenData(token);
  return {
    username: username ?? undefined,
    tokenExpiresAt: exp ? new Date(exp * 1000 /* s => ms */) : undefined,
    token: token,
    refreshToken: refreshToken ?? undefined,
  };
}

export function authReducer(
  state: AuthState | undefined,
  action: AuthActionTypes,
): AuthState {
  if (state === undefined) {
    return parseToken(
      LocalStorageService.getToken(),
      LocalStorageService.getRefreshToken(),
    );
  }

  switch (action.type) {
    case LOGGED_IN:
      LocalStorageService.setToken(action.token);
      LocalStorageService.setRefreshToken(action.refreshToken);
      return parseToken(action.token, action.refreshToken);
    case LOGGED_OUT:
      return {};
    case SET_REFRESH_IN_PROGRESS:
      return { ...state, refreshInProgress: action.refreshInProgress };
    default:
      return state;
  }
}
